import React from "react";
import { formatRubles } from "@/utils/helpers";
import { useDashboardStore } from "@/store/dashboardStore";
import cls from "./styles.module.scss";

export const AllTimeTotals = () => {
  const dashboardInfo = useDashboardStore((s) => s.dashboardInfo);

  if (!dashboardInfo) return null;

  return (
    <>
      <div className={cls.row}>
        <span>Всего рефералов</span>
        <b>{dashboardInfo.all_time.registered.toLocaleString("ru-RU")}</b>
      </div>
      <div className={cls.row}>
        <span>Заработано за всё время</span>
        <b>{formatRubles(dashboardInfo.all_time.accrued)}</b>
      </div>
    </>
  );
};
